import { useRouter } from "next/router"
import React, { useMemo, useState } from "react"

import { WorkFlowFooter } from "@common/workflow/workflow"
import Alert from "@common/alert"
import { DropDownOptions } from "@common/v2/dropdowns/types"
import { Behavior, Fields } from "@common/v2/form/types"
import { FormState } from "@common/forms/types"
import Form from "@common/v2/form"
import DefaultLayout from "@common/v2/form/layouts/default"
import { getAccountDetails, updateAccountDetails } from "@common/network"
import { addQueryParam } from "@common/lib/navigation"
export const options = {
  Analyst: {
    key: "Analyst",
    display: "Analyst",
  },
  "Analytics Manager": {
    key: "Analytics Manager",
    display: "Analytics Manager",
  },
  "Business Development": {
    key: "Business Development",
    display: "Business Development",
  },
  "Customer Success": {
    key: "Customer Success",
    display: "Customer Success",
  },
  Founder: {
    key: "Founder",
    display: "Founder",
  },
  Freelancer: {
    key: "Freelancer",
    display: "Freelancer",
  },
  "Growth Marketer": {
    key: "Growth Marketer",
    display: "Growth Marketer",
  },
  "Marketing Manager": {
    key: "Marketing Manager",
    display: "Marketing Manager",
  },
  Other: {
    key: "Other",
    display: "Other",
  },
  "Product Manager": {
    key: "Product Manager",
    display: "Product Manager",
  },
  Seller: {
    key: "Seller",
    display: "Seller",
  },
}

export const fields: Fields = {
  customer_name: {
    element: "input",
    label: {
      label: "Full Name",
    },
    validation: { required: true },
  },
  company_name: {
    element: "input",
    label: {
      label: "Company",
    },
    validation: { required: true },
  },
  designation: {
    element: "listbox",
    label: {
      label: "Designation",
    },
    options: options,
    validation: { required: true },
  },

  other: {
    placeholder: "Designation",
    element: "input",
    validation: { required: true, maxLength: 30 },
    label: {
      label: "",
    },
    invisible: true,
  },
}
const PersonalProfile = () => {
  const { data } = getAccountDetails()
  const [details, setDetails] = useState({})
  const router = useRouter()
  const [errorMessage, setErrorMessage] = useState<string | string[]>()

  const initialState = useMemo(() => getInitialValues(data, options), [data])

  return (
    <div className="flex flex-col mt-20 max-w-md mx-auto">
      <h2 className=" font-bold text-2xl text-center">Tell us about yourself!</h2>
      {renderForm()}
      {errorMessage && <Alert variant="error">{errorMessage}</Alert>}
      <div className="flex justify-end mt-10">
        <WorkFlowFooter
          submitFunction={() =>
            submitFunction(
              details,
              setErrorMessage,
              addQueryParam(router.asPath, "step", "1")
            )
          }
          onSubmitFail={(message) => setErrorMessage(message)}
          handleNextClick={undefined}
        />
      </div>
    </div>
  )

  function renderForm() {
    return (
      <div className="max-w-md">
        <Form
          fields={fields}
          onStateChange={(details) => setDetails(details)}
          initialFormState={initialState}
          behaviors={behaviors}
        >
          <DefaultLayout />
        </Form>
      </div>
    )
  }
}

const submitFunction = (details: FormState, setErrorMessage: any, path: string) => {
  const designation = getDesignationFromFormDetails(details)
  // if (!designation) {
  //   setErrorMessage && setErrorMessage("Designation is required")
  //   return Promise.resolve({})
  // }
  const accountDetails = {
    ...details,
    designation,
    home_path: path,
  }
  return updateAccountDetails(accountDetails)
}

// export function sortOptions(optionArr) {
//   return optionArr.reduce((prev, curr) => {
//     const key = curr.toLowerCase().replace(/\s+/g, "_")
//     return {
//       ...prev,
//       [key]: { key, display: curr },
//     }
//   }, {})
// }

export function getInitialValues(
  data: Record<string, any>,
  options: DropDownOptions
) {
  const { company_name, customer_name, designation } = data || {}
  const isOther = designation && !options[designation]
  return {
    company_name,
    customer_name,
    designation: isOther ? "Other" : designation,
    other: isOther ? designation : undefined,
  }
}

export function getDesignationFromFormDetails(details: FormState) {
  const { designation, other } = details
  return designation === "Other" ? other : designation
}

export const behaviors: Behavior[] = [
  {
    name: "Show other for designation",
    conditions: [
      { type: "rule", field: "designation", operator: "equals", value: "Other" },
    ],
    actions: [{ type: "show", targetField: "other" }],
  },
]
// export function getProfileFormConfig(options: SelectOptions): Fields {
//   // options = { "": { key: "", display: "Choose your designation" }, ...options }
//   return
//   }
// }

export default PersonalProfile
